// subSectionScores is an array of arrays, each with score, weight
// ex: for patient readiness - [[56, 0.5], [35, 0.5]]
export default (subSectionScores) => {
    const weightedScores = subSectionScores.map((subSection) => subSection[0] * subSection[1])
    return Math.round(weightedScores.reduce((acc, cur) => acc + cur))
}


// WEBPACK FOOTER //
// ./src/selectors/sectionScore.js